module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDE2IDIwIj4KICAgIDxwYXRoIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjODg4Qjk0IiBzdHJva2Utd2lkdGg9IjIiCiAgICAgICAgICBkPSJNOCAxYTcgNyAwIDAgMC03IDdjMCA0LjAyOCA0LjU0MyA5LjA2MSA2LjMxIDEwLjcyOGEuOTkuOTkgMCAwIDAgMS4zNjctLjAwM0MxMC40MzQgMTcuMDU3IDE1IDEyLjAyNiAxNSA4YTcgNyAwIDAgMC03LTd6bTAgMTBhMyAzIDAgMSAxIDAtNiAzIDMgMCAwIDEgMCA2eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-pin.svg
// module id = m/Lu
// module chunks = 0